import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { performanceHeaderSubmit } from '../../../../store/apis/performanceService';

function ConfirmationModal({
  hasPreviousCall,
  selectedEmployee,
  performanceHeader,
  refetchPerformanceHeader,
  heading,
  isModal,
  toggleModal,
}) {
  const headerData = performanceHeader?.[0] || {};

  const { mutate: headerSubmit } = useMutation({
    mutationFn: performanceHeaderSubmit,
    onSuccess: () => {
      toast.success('Submitted successfully!', {
        className: 'toast-success',
      });
      refetchPerformanceHeader();
    },
    onError: error => {
      toast.error(error?.message || 'Failed to submit data', {
        className: 'toast-error',
      });
    },
  });

  const onPerformHeaderSubmit = () => {
    let status = 'Define_Objectives';
    if (hasPreviousCall) {
      if (headerData.Calibration_Result === 2) {
        status = 'Manager_Review';
      } else if (headerData.Manager_Review === 2) {
        status = 'Self_Assessment';
      } else if (headerData.Self_Assessment === 2) {
        status = 'Confirm_Objectives';
      } else if (headerData.Confirm_Objectives === 2) {
        status = 'Define_Objectives';
      } else if (headerData.Define_Objectives === 2) {
        status = 'Reset';
      } else {
        toast.error('You cannot go to the previous step at this stage.');
        toggleModal();
        return;
      }
    } else if (headerData.Define_Objectives === 1) {
      status = 'Define_Objectives';
    } else if (headerData.Confirm_Objectives === 1) {
      status = 'Confirm_Objectives';
    } else if (headerData.Self_Assessment === 1) {
      status = 'Self_Assessment';
    } else if (headerData.Manager_Review === 1) {
      status = 'Manager_Review';
    } else if (headerData.Calibration_Result === 1) {
      status = 'Calibration_Result';
    } else {
      status = 'Define_Objectives';
    }

    const payload = {
      employeeId: selectedEmployee?.value,
      userId: '',
      status,
    };
    headerSubmit(payload);
    toggleModal();
  };

  return (
    <Modal
      isOpen={isModal}
      toggle={toggleModal}
      modalClassName="custom-modal-size"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggleModal}>Confirm Submission</ModalHeader>
      <ModalBody>{heading}</ModalBody>
      <ModalFooter className="modalFooter">
        <Button className="item custom-light-btn" onClick={toggleModal}>
          No
        </Button>
        <Button className="item custom-btn" onClick={onPerformHeaderSubmit}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmationModal;
